module.exports = __webpack_public_path__ + "img/stop_btn.45e8c61e.png";